import { useStore } from '../store/state';

export const useLanguageExtension = () => {
  const [{ contentState }] = useStore();
  const locale = contentState.localLangCode || 'en-GB';
  const languageExtension = locale === 'en-GB' ? '' : `.${locale}`;
  return languageExtension;
};
